export default "__VITE_ASSET__BabZaXXu__"